export default __webpack_public_path__ + "static/media/logo-app-store.c4d11ec7.png";